import { DatabaseModel, DatabaseModelElement } from "./DatabaseModel";
import { TableCell, TableRow } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import React from "react";
// @ts-ignore
import { Link } from "react-router";
import { formatDate } from "../utils/formatDate";
import axios, { AxiosResponse } from "axios";

export default class Debtor extends DatabaseModel implements DatabaseModelElement {
  static modelName = "subsDebtor";
  id: number;
  company_name: string;
  company_address: string;
  company_city: string;
  company_country: string;
  company_postal_code: string;
  coc_number: string;
  vat_number: string;
  gripp_reference: string;
  gripp_created_at: Date;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date | null;

  constructor(
    id: number,
    company_name: string = "",
    company_address: string = "",
    company_city: string = "",
    company_country: string = "",
    company_postal_code: string = "",
    coc_number: string = "",
    vat_number: string = "",
    gripp_reference: string = "",
    gripp_created_at: string = "",
    created_at: string = "",
    updated_at: string = "",
    deleted_at: string | null = null
  ) {
    super();
    this.id = id;
    this.company_name = company_name;
    this.company_address = company_address;
    this.company_city = company_city;
    this.company_country = company_country;
    this.company_postal_code = company_postal_code;
    this.coc_number = coc_number;
    this.vat_number = vat_number;
    this.gripp_reference = gripp_reference;
    this.gripp_created_at = new Date(gripp_created_at);
    this.created_at = new Date(created_at);
    this.updated_at = new Date(updated_at);
    this.deleted_at = deleted_at ? new Date(deleted_at) : null;
  }

  static CreateModel(model: any): Debtor {
    return new Debtor(
      model.id,
      model.company_name,
      model.company_address,
      model.company_city,
      model.company_country,
      model.company_postal_code,
      model.coc_number,
      model.vat_number,
      model.gripp_reference,
      model.gripp_created_at,
      model.created_at,
      model.updated_at,
      model.deleted_at
    );
  }

  static importDebtors(): Promise<any> {
    return new Promise((resolve: (value: any) => void, reject) => {
      axios
        .get("core/" + this.modelName + "/import")
        .then((response: AxiosResponse) => {
          resolve({ response });
        })
        .catch((err) => reject(err));
    });
  }

  tableRow() {
    return (
      <TableRow>
        <TableCell>{this.company_name}</TableCell>
        <TableCell>{this.company_city}</TableCell>
        <TableCell>{formatDate(this.gripp_created_at)}</TableCell>
        <TableCell>
          <Link to={{ pathname: Debtor.editPath(this.id) }}>
            <Visibility />
          </Link>
        </TableCell>
      </TableRow>
    );
  }
}
